var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_user-agent.js
// module id = 87
// module chunks = 0 2 3 4 5 6 7 8 11 12 13 14 15 16 17 18 20